//Function to modify a link to the ilp pdf file.
export const modifyUrl = (originalUrl: string | null) : string => {
    const fileName = originalUrl?.split('\\').pop();
    const BASE_URL_TO_ILP_PDF = process.env.REACT_APP_BASE_URL_TO_ILP_PDF;
    const newUrl = `${BASE_URL_TO_ILP_PDF}${fileName}`;
    return newUrl;
};